import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { IhmExpandCollapseLevel } from './ihm-expand-collapse-level.enum';

@Component({
  selector: 'app-ihm-expand-collapse-panel',
  templateUrl: './ihm-expand-collapse-panel.component.html',
  styleUrls: ['./ihm-expand-collapse-panel.component.scss']
})
export class IhmExpandCollapsePanelComponent implements OnChanges {
  constructor() {}

  @Input() readonly type: string;
  @Input() readonly isExpanded: boolean = false;

  public buttonType: string = 'expansion-highest';

  ngOnChanges(changes: SimpleChanges) {
    if ('type' in changes) {
      if (this.type == IhmExpandCollapseLevel.HIGHEST) this.buttonType = 'expansion-highest';
      else if (this.type == IhmExpandCollapseLevel.MID) this.buttonType = 'expansion-mid';
      else this.buttonType = 'expansion-low';
    }
  }
}
